import { createReducer } from '@reduxjs/toolkit';

import {
	i18nChangeLanguage,
	i18nLoadFailure,
	i18nLoadRequest,
	i18nLoadSuccess,
} from './i18nActions';

export type I18nState = {
	langCode: string;
	loading: boolean;
	error?: string;

	bundle?: Record<string, string>;
};

const initialState: I18nState = {
	langCode: 'en',
	loading: false,
};

export const i18nReducer = createReducer(initialState, b => {
	b.addCase(i18nLoadRequest, (s, a) => {
		s.loading = true;
		s.error = undefined;
		s.langCode = a.payload.langCode;
	});
	b.addCase(i18nLoadSuccess, (s, a) => {
		s.loading = false;
		s.bundle = a.payload.bundle;
	});
	b.addCase(i18nLoadFailure, (s, a) => {
		s.loading = false;
		s.error = a.payload;
	});
	b.addCase(i18nChangeLanguage, (s, a) => {
		s.langCode = a.payload.langCode;
	});
});
